import AcUnitIcon from '@mui/icons-material/AcUnit'
import WhatshotIcon from '@mui/icons-material/Whatshot'
import Chip from '@mui/material/Chip'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { getControl } from '../../store/ControlById/selectors'
import { getHouse } from '../../store/HouseById/selectors'
import { Control, Log, State } from '../../types'

// 三方弁の現在モードを親HPの hp{pumpNumber}_mode から求める（0=冷却, 1=加温）。
// backend: Event#current_hp_mode 参照。tway1/tway2 は弁の開度でありモードではない。
const getTwayMode = (
	lastLog: Log | null,
	pumpNumber: number | null | undefined,
): 'heating' | 'cooling' | null => {
	if (!lastLog || pumpNumber == null) return null
	const raw =
		pumpNumber === 1
			? lastLog.hp1Mode
			: pumpNumber === 2
			? lastLog.hp2Mode
			: null
	if (raw === null || raw === undefined) return null
	return raw === 1 ? 'heating' : 'cooling'
}

type Props = {
	control: Control
	size?: 'small' | 'medium'
}

// 三方弁の行/セルに、現在の（加温/冷却）モードを色付きバッジで表示する
const TwayModeBadge = ({ control, size = 'small' }: Props) => {
	const house = useSelector((s: State) => getHouse(s, control.houseId))
	// 読み取り時 API の parent_hp_id（camel化で parentHpId）にも念のため対応する
	const relatedHpId =
		control.relatedHpId ??
		(control as { parentHpId?: number | null }).parentHpId ??
		null
	const relatedHp = useSelector((s: State) =>
		relatedHpId != null ? getControl(s, relatedHpId) : undefined,
	)
	const mode = getTwayMode(house?.lastLog ?? null, relatedHp?.pumpNumber)

	if (!mode) return null
	const isHeating = mode === 'heating'

	return (
		<Chip
			size={size}
			icon={isHeating ? <WhatshotIcon /> : <AcUnitIcon />}
			label={isHeating ? '加温' : '冷却'}
			sx={{
				height: 20,
				fontSize: 11,
				fontWeight: 'bold',
				color: 'white',
				bgcolor: isHeating ? '#e2603a' : '#3a7bd5',
				ml: 0,
				'& .MuiChip-label': { px: 0.75 },
				'& .MuiChip-icon': {
					fontSize: 13,
					ml: '5px',
					mr: '-3px',
					color: 'white',
				},
			}}
		/>
	)
}

export default TwayModeBadge
